export const CssBreakpoints = {
  XS: 430,
  SM: 644,
  MD: 768,
  LG: 992,
  XL: 1200,
};
